module.exports = __webpack_public_path__ + "img/tiger_visual.7846680f.jpg";